'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AUITooltip = function AUITooltip(_ref) {
  var gravity = _ref.gravity,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ['gravity', 'children']);

  return _react2.default.createElement(
    'div',
    _extends({ role: 'tooltip', className: 'tipsy tipsy-' + gravity }, otherProps),
    _react2.default.createElement('div', { className: 'tipsy-arrow tipsy-arrow-' + gravity }),
    _react2.default.createElement(
      'div',
      { className: 'tipsy-inner' },
      children
    )
  );
};

AUITooltip.displayName = 'AUITooltip';
AUITooltip.defaultProps = {
  style: {}
};

AUITooltip.propTypes = {
  /**
   * Children elements such as title for the tooltip
   */
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  /**
   * Direction and position for the tooltip
   */
  gravity: _propTypes2.default.oneOf(['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw']).isRequired,
  /**
   * Custom style
   */
  style: _propTypes2.default.object,
  /**
   * On mouse enter event handler
   */
  onMouseEnter: _propTypes2.default.func,
  /**
   * On mouse leave event handler
   */
  onMouseLeave: _propTypes2.default.func
};

exports.default = AUITooltip;
//# sourceMappingURL=AUITooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/aui-react/lib/AUITooltip.js
// module id = 200
// module chunks = 0